export default __webpack_public_path__ + "media/src/assets/images/platform_logo-f7b21c966764df0567546417a0b4fec9.svg";